/*
 * jQuery MultiSelect UI Widget 1.13
 * Copyright (c) 2012 Eric Hynds
 *
 * http://www.erichynds.com/jquery/jquery-ui-multiselect-widget/
 *
 * Depends:
 *   - jQuery 1.4.2+
 *   - jQuery UI 1.8 widget factory
 *
 * Optional:
 *   - jQuery UI effects
 *   - jQuery UI position utility
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
 */
/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, boss:true, undef:true, curly:true, browser:true, jquery:true */
/*
 * jQuery MultiSelect UI Widget 1.13
 * Copyright (c) 2012 Eric Hynds
 *
 * http://www.erichynds.com/jquery/jquery-ui-multiselect-widget/
 *
 * Depends:
 *   - jQuery 1.4.2+
 *   - jQuery UI 1.8 widget factory
 *
 * Optional:
 *   - jQuery UI effects
 *   - jQuery UI position utility
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
*/

/* fastdom https://github.com/wilsonpage/fastdom */
!function(t){"use strict";function e(){var e=this;e.reads=[],e.writes=[],e.raf=u.bind(t)}function n(t){t.scheduled||(t.scheduled=!0,t.raf(i.bind(null,t)))}function i(t){var e,i=t.writes,o=t.reads;try{o.length,r(o),i.length,r(i)}catch(t){e=t}if(t.scheduled=!1,(o.length||i.length)&&n(t),e){if(e.message,!t.catch)throw e;t.catch(e)}}function r(t){for(var e;e=t.shift();)e()}function o(t,e){var n=t.indexOf(e);return!!~n&&!!t.splice(n,1)}function s(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])}var u=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.msRequestAnimationFrame||function(t){return setTimeout(t,16)};e.prototype={constructor:e,measure:function(t,e){var i=e?t.bind(e):t;return this.reads.push(i),n(this),i},mutate:function(t,e){var i=e?t.bind(e):t;return this.writes.push(i),n(this),i},clear:function(t){return o(this.reads,t)||o(this.writes,t)},extend:function(t){if("object"!=typeof t)throw new Error("expected object");var e=Object.create(this);return s(e,t),e.fastdom=this,e.initialize&&e.initialize(),e},catch:null};var exports=t.fastdom=t.fastdom||new e;"function"==typeof define?define(function(){return exports}):"object"==typeof module&&(module.exports=exports)}("undefined"!=typeof window?window:this);
/* end fastdom */

(function($, undefined){

var multiselectID = 0;

function getjQueryFromElement(elem) {
	if(!!elem.jquery) {
	return elem;
	}
	if(!!elem.nodeType) {
	return $(elem);
	}

	return $(elem).eq(0);
}

$.widget("ech.multiselect", {

	// default options
	options: {
		header: true,
		height: 175,
		minWidth: 225,
		classes: '',
		checkAllText: locale.get("Check all"),
		uncheckAllText: locale.get("Uncheck all"),
		noneSelectedText: locale.get("Select options"),
		selectedText: "# " + locale.get("selected"),
		selectedList: 0,
		show: null,
		hide: null,
		autoOpen: false,
		multiple: true,
		appendTo: null,
        position: {},
        renderOnDemand: false,
        renderOnDemandStep: 0,
        totalOptions: 0
	},

	_getAppendEl: function() {
		var elem = this.options.appendTo;

		if (elem) {
		elem = getjQueryFromElement(elem);
		}
		if (!elem || !elem[0]) {
		elem = this.element.closest('.ui-front, dialog');
		}
		if (!elem.length) {
		elem = $(document.body);
		}
		return elem;
	},

	_create: function(){
		var el = this.element.css('display', 'none').addClass('ui-multiselect-element'),
			o = this.options;

        o.totalOptions = el.find("option").length;
        // limit is bigger than the number of options filter has
        // disable render on demand
        if (o.totalOptions < o.renderOnDemandStep)
            o.renderOnDemand = false;

		this.speed = $.fx.speeds._default; // default speed for effects
		this._isOpen = false; // assume no

		var appendEl = this._getAppendEl();

		var
			button = (this.button = $('<button type="button"><span class="ui-icon ui-icon-triangle-2-n-s"></span></button>'))
				.addClass('ui-multiselect ui-widget ui-state-default ui-corner-all')
				.addClass( o.classes )
				.attr({ 'title':el.attr('title'), 'aria-haspopup':true, 'tabIndex':el.attr('tabIndex') })
				.insertAfter( el ),

			buttonlabel = (this.buttonlabel = $('<span />'))
				.html( o.noneSelectedText )
				.appendTo( button ),

			menu = (this.menu = $('<div />'))
				.addClass('ui-multiselect-menu ui-widget ui-widget-content ui-corner-all')
				.addClass( o.classes )
				.appendTo( appendEl ),

			header = (this.header = $('<div />'))
				.addClass('ui-widget-header ui-corner-all ui-multiselect-header ui-helper-clearfix')
				.appendTo( menu ),

			headerLinkContainer = (this.headerLinkContainer = $('<ul />'))
				.addClass('ui-helper-reset')
				.html(function(){
					if( o.header === true ){
						return '<li><a class="ui-multiselect-all" href="#"><span class="ui-icon ui-icon-check"></span><span>' + o.checkAllText + '</span></a></li><li><a class="ui-multiselect-none" href="#"><span class="ui-icon ui-icon-closethick"></span><span>' + o.uncheckAllText + '</span></a></li>';
					} else if(typeof o.header === "string"){
						return '<li>' + o.header + '</li>';
					} else {
						return '';
					}
				})
				.append('<li class="ui-multiselect-close"><a href="#" class="ui-multiselect-close"><span class="ui-icon ui-icon-circle-close"></span></a></li>')
				.appendTo( header ),

			checkboxContainer = (this.checkboxContainer = $('<ul />'))
				.addClass('ui-multiselect-checkboxes ui-helper-reset')
				.appendTo( menu );

		// Use $.extend below since the "of" position property may not be able to be supplied via the option.
		o.position = $.extend({'my': 'left top', 'at': 'left bottom', 'of': button}, o.position || {});

		// perform event bindings
		this._bindEvents();

		// build menu
		this.refresh( true );

		// some addl. logic for single selects
		if( !o.multiple ){
			menu.addClass('ui-multiselect-single');
		}
	},

	_init: function(){
		if( this.options.header === false ){
			this.header.css('display', 'none')
		}
		if( !this.options.multiple ){
			this.headerLinkContainer.find('.ui-multiselect-all, .ui-multiselect-none').css('display', 'none')
		}
		if( this.options.autoOpen ){
			this.open();
		}
		if( this.element.is(':disabled') ){
			this.disable();
		}
    },

    getOptionsHtml: function (options, toRender) {
        var el = this.element,
            o = this.options,
            optgroups = [],
            id = el.attr('id') || multiselectID++,
            html = "",
            renderedOptions = 0;

        options.each(function (i) {
            // already rendered N options, break
            if (o.renderOnDemand && renderedOptions >= toRender)
                return false;
            // increase count
            renderedOptions++;

            var $this = $(this),
                parent = this.parentNode,
                title = this.innerHTML,
                description = this.title,
                value = this.value,
                inputID = 'ui-multiselect-' + (this.id || id + '-option-' + value),
                isDisabled = this.disabled,
                isSelected = this.selected,
                isHidden = this.hasAttribute('hidden'), // to make IE9/10 and play nice
                labelClasses = ['ui-corner-all'],
                liClasses = (isDisabled ? 'ui-multiselect-disabled ' : ' ') + this.className,
                optLabel;

            // is this an optgroup?
            if (parent.tagName === 'OPTGROUP') {
                optLabel = parent.getAttribute('label');

                // has this optgroup been added already?
                if ($.inArray(optLabel, optgroups) === -1) {
                    html += '<li class="ui-multiselect-optgroup-label ' + parent.className + '"><a href="#">' + optLabel + '</a></li>';
                    optgroups.push(optLabel);
                }
            }

            if (isDisabled) {
                labelClasses.push('ui-state-disabled');
            }

            if (isHidden) {
                liClasses += 'ui-multiselect-hidden'
                labelClasses.push('ui-state-hidden');
            }

            // browsers automatically select the first option
            // by default with single selects
            if (isSelected && !o.multiple) {
                labelClasses.push('ui-state-active');
            }

            html += '<li class="' + liClasses + '" id="li_' + id + '-' + value + '">';

            // create the label
            html += '<label for="' + inputID + '" title="' + description + '" class="' + labelClasses.join(' ') + '">';
            html += '<input id="' + inputID + '" name="multiselect_' + id + '" type="' + (o.multiple ? "checkbox" : "radio") + '" value="' + value + '" title="' + title + '"';

            // pre-selected?
            if (isSelected) {
                html += ' checked="checked"';
                html += ' aria-selected="true"';
            }

            // disabled?
            if (isDisabled) {
                html += ' disabled="disabled"';
                html += ' aria-disabled="true"';
            }

            // hidden?
            if (isHidden) {
                html += ' hidden="hidden"';
            }

            // add the title and close everything off
            html += ' /><span>' + title + '</span></label></li>';
        });

        return html;
    },

	refresh: function( init ){
		var el = this.element,
			o = this.options,
			menu = this.menu,
			checkboxContainer = this.checkboxContainer,
			optgroups = [],
			html = "",
            id = el.attr('id') || multiselectID++; // unique ID for the label & option tags

        // render on demand: render renderOnDemandStep or up to last selected
        //var renderedOptions = 0;
        var lastSelected = el.find('option:selected').last().index();
        var toRender = Math.max(o.renderOnDemandStep, lastSelected + 1);

        html = this.getOptionsHtml(el.find('option'), toRender);

		// insert into the DOM
		checkboxContainer.html( html );

		// cache some moar useful elements
		this.labels = menu.find('label');
		this.inputs = this.labels.children('input');

		// set widths
		this._setButtonWidth();
		this._setMenuWidth();

		// remember default value
		this.button[0].defaultValue = this.update();

		// broadcast refresh event; useful for widgets
		if( !init ){
			this._trigger('refresh');
		}
    },

    // used when render on demand is on to render more ddl options
    renderMore: function (scroll, all) {
        var el = this.element,
            o = this.options,
            menu = this.menu,
            checkboxContainer = this.checkboxContainer,
            html = checkboxContainer.html(),
            searchTerm = this.menu.find(".ui-multiselect-filter input").length > 0 ? $.trim(this.menu.find(".ui-multiselect-filter input")[0].value.toLowerCase()) : "";

        var toRender = o.renderOnDemandStep;

        var notRenderedOptions = el.find('option').slice(this.labels.length);
        if (all)
            toRender = notRenderedOptions.length;
        var lastMatchIndex = 0;

		if (!all) {
			var rEscape = /[\-\[\]{}()*+?.,\\\^$|#\s]/g;
			var regex = new RegExp(searchTerm.replace(rEscape, "\\$&"), 'gi');
			var minimumToRender = o.renderOnDemandStep;
			var optionsToMatch = scroll ? notRenderedOptions : el.find("option");
			optionsToMatch.each(function () {
				if (minimumToRender <= 0)
					return false;
				if ($(this).is('[hidden]'))
					return;
				if (!searchTerm || $(this).text().search(regex) !== -1) {
					lastMatchIndex = $(this).index();
					minimumToRender--;
				}
			});

			if (lastMatchIndex > 0 && lastMatchIndex + 1 > this.labels.length)
				toRender = lastMatchIndex + 1 - this.labels.length;
			else
				return;
		}

        html += this.getOptionsHtml($(notRenderedOptions), toRender);

        // insert into the DOM
        checkboxContainer.html(html);

        // cache some moar useful elements
        this.labels = menu.find('label');
        this.inputs = this.labels.children('input');

        // set widths
        this._setButtonWidth();
        this._setMenuWidth();

        // remember default value
        this.button[0].defaultValue = this.update();

        // broadcast refresh event; useful for widgets
        this._trigger('refresh');

        if (o.totalOptions > this.labels.length)
            this._bindScrollEvent();
    },

	// updates the button text. call refresh() to rebuild
	update: function(){
		var o = this.options,
			$inputs = this.inputs,
			$checked = $inputs.filter(':checked'),
			numChecked = $checked.length,
			value;

		if( numChecked === 0 ){
			value = o.noneSelectedText;
		} else {
			if($.isFunction( o.selectedText )){
				value = o.selectedText.call(this, numChecked, $inputs.length, $checked.get());
			} else if( /\d/.test(o.selectedList) && o.selectedList > 0 && numChecked <= o.selectedList){
				value = $checked.map(function(){ return $(this).next().html(); }).get().join(', ');
			} else {
				value = o.selectedText.replace('#', numChecked).replace('#', $inputs.length);
			}
		}

		this.buttonlabel.html( value );
		return value;
	},

	// binds events
	_bindEvents: function(){
		var self = this, button = this.button;

		function clickHandler(){
			if (!button.is(':disabled')) {
				self[ self._isOpen ? 'close' : 'open' ]();
			}
			return false;
		}

		// webkit doesn't like it when you click on the span :(
		button
			.find('span')
			.bind('click.multiselect', clickHandler);

		// button events
		button.bind({
			click: clickHandler,
			keypress: function( e ){
				switch(e.which){
					case 27: // esc
					case 38: // up
					case 37: // left
						self.close();
						break;
					case 39: // right
					case 40: // down
						self.open();
						break;
				}
			},
			mouseenter: function(){
				if( !button.hasClass('ui-state-disabled') ){
					$(this).addClass('ui-state-hover');
				}
			},
			mouseleave: function(){
				$(this).removeClass('ui-state-hover');
			},
			focus: function(){
				if( !button.hasClass('ui-state-disabled') ){
					$(this).addClass('ui-state-focus');
				}
			},
			blur: function(){
				$(this).removeClass('ui-state-focus');
			}
		});

		// header links
		this.header
			.delegate('a', 'click.multiselect', function( e ){
				// close link
				if( $(this).hasClass('ui-multiselect-close') ){
					self.close();

				// check all / uncheck all
				} else {
					self[ $(this).hasClass('ui-multiselect-all') ? 'checkAll' : 'uncheckAll' ]();
				}

				e.preventDefault();
			});

		// optgroup label toggle support
		this.menu
			.delegate('li.ui-multiselect-optgroup-label a', 'click.multiselect', function( e ){
				e.preventDefault();

				var $this = $(this),
					$inputs = $this.parent().nextUntil('li.ui-multiselect-optgroup-label').find('input:visible:not(:disabled)'),
					nodes = $inputs.get(),
					label = $this.parent().text();

				// trigger event and bail if the return is false
				if( self._trigger('beforeoptgrouptoggle', e, { inputs:nodes, label:label }) === false ){
					return;
				}

				// toggle inputs
				self._toggleChecked(
					$inputs.filter(':checked').length !== $inputs.length,
					$inputs
				);

				self._trigger('optgrouptoggle', e, {
				    inputs: nodes,
				    label: label,
				    checked: nodes[0].checked
				});
			})
			.delegate('label', 'mouseenter.multiselect', function(){
				if( !$(this).hasClass('ui-state-disabled') ){
					var scrollX = window.pageXOffset;
					var scrollY = window.pageYOffset;
					
					self.labels.removeClass('ui-state-hover');
					$(this).addClass('ui-state-hover').find('input').focus();

					// Restore scroll positions if altered by setting input focus
					window.scrollTo(scrollX, scrollY);
				}
			})
			.delegate('label', 'keydown.multiselect', function( e ){
				e.preventDefault();

				switch(e.which){
					case 9: // tab
					case 27: // esc
						self.close();
						break;
					case 38: // up
					case 40: // down
					case 37: // left
					case 39: // right
						self._traverse(e.which, this);
						break;
					case 13: // enter
						$(this).find('input')[0].click();
						break;
				}
			})
			.delegate('input[type="checkbox"], input[type="radio"]', 'click.multiselect', function( e ){
				var $this = $(this),
					val = this.value,
					checked = this.checked,
					tags = self.element.find('option');
				
				var scrollX = window.pageXOffset;
				var scrollY = window.pageYOffset;

				// bail if this input is disabled or the event is cancelled
				if( this.disabled || self._trigger('click', e, { value: val, text: this.title, checked: checked }) === false ){
					e.preventDefault();
					return;
				}

				// make sure the input has focus. otherwise, the esc key
				// won't close the menu after clicking an item.
				$this.focus();

				// toggle aria state
				$this.attr('aria-selected', checked);

				// change state on the original option tags
				tags.each(function(){
					if( this.value === val ){
						this.selected = checked;
					} else if( !self.options.multiple ){
						this.selected = false;
					}
				});

				// some additional single select-specific logic
				if( !self.options.multiple ){
					self.labels.removeClass('ui-state-active');
					$this.closest('label').toggleClass('ui-state-active', checked );

					// close menu
					self.close();
				}

				// fire change on the select box
				self.element.trigger("change");

				// Restore window scroll position if altered by setting element focus
				window.scrollTo(scrollX, scrollY);

				// setTimeout is to fix multiselect issue #14 and #47. caused by jQuery issue #3827
				// http://bugs.jquery.com/ticket/3827
				setTimeout($.proxy(self.update, self), 10);
            });

        this._bindScrollEvent();
        

		// close each widget when clicking on any other element/anywhere else on the page
		$(document).bind('mousedown.multiselect', function( e ){
			if(self._isOpen && !$.contains(self.menu[0], e.target) && !$.contains(self.button[0], e.target) && e.target !== self.button[0]){
				self.close();
			}
		});

		// deal with form resets.  the problem here is that buttons aren't
		// restored to their defaultValue prop on form reset, and the reset
		// handler fires before the form is actually reset.  delaying it a bit
		// gives the form inputs time to clear.
		$(this.element[0].form).bind('reset.multiselect', function(){
			setTimeout($.proxy(self.refresh, self), 10);
		});
    },

    _bindScrollEvent: function () {
        var self = this;
        // render on demand is enabled - bind scroll event
        if (this.options.renderOnDemand)
            this.menu.find(".ui-multiselect-checkboxes").unbind("scroll").bind("scroll", function () {
                // have already rendered all options? unbind event
                if (self.labels.length >= self.options.totalOptions) {
                    self.menu.find(".ui-multiselect-checkboxes").unbind("scroll");
                    return;
                }
                // get scroll position
                var scrollPosition = $(this).position().top + $(this).height();
                var lastOption = $(this).find("li:last");
                var lastOptionY = lastOption.height() + lastOption.position().top - 4;

                // reached the end? render more options
                if (scrollPosition > lastOptionY) {
                    // unbind to avoid overdoing it
                    self.menu.find(".ui-multiselect-checkboxes").unbind("scroll");
                    self.renderMore(true);
                }
            });
    },

	// set button width
	_setButtonWidth: function() {
		var width;

		fastdom.measure(() => {
			width = this.element.outerWidth(),
				o = this.options;
		});

		fastdom.mutate(() => {
			if ( /\d/.test(o.minWidth) && width < o.minWidth) {
				width = o.minWidth;
			}
	
			// set widths
			jQuery.modern ?	this.button.outerWidth( width ) : this.button.width( width );
		});
	},

	// set menu width
	_setMenuWidth: function() {
		var m = this.menu,
			width;

		fastdom.measure(() => {
			width = this.button.outerWidth()-
				parseInt(m.css('padding-left'),10)-
				parseInt(m.css('padding-right'),10)-
				parseInt(m.css('border-right-width'),10)-
				parseInt(m.css('border-left-width'),10);
		});

		fastdom.mutate(() => {
			m.width( width || this.button.outerWidth() );
		});
	},

	// move up or down within the menu
	_traverse: function( which, start ){
		var $start = $(start),
			moveToLast = which === 38 || which === 37,

			// select the first li that isn't an optgroup label / disabled
			$next = $start.parent()[moveToLast ? 'prevAll' : 'nextAll']('li:not(.ui-multiselect-disabled, .ui-multiselect-optgroup-label)')[ moveToLast ? 'last' : 'first']();

		// if at the first/last element
		if( !$next.length ){
            // render on demand is on, there are more options that can be rendered and we've reached the end of dropdown list
            if (this.options.renderOnDemand && this.options.totalOptions > this.labels.length && (which == 40 || which == 39)) {
                // render more options
                this.renderMore(true);
            } else {
                var $container = this.menu.find('ul').last();

                // move to the first/last
                this.menu.find('label')[moveToLast ? 'last' : 'first']().trigger('mouseover');

                // set scroll position
                $container.scrollTop(moveToLast ? $container.height() : 0);
            }

		} else {
			$next.find('label').trigger('mouseover');
		}
	},

	// This is an internal function to toggle the checked property and
	// other related attributes of a checkbox.
	//
	// The context of this function should be a checkbox; do not proxy it.
	_toggleState: function( prop, flag ){
		return function(){
			if( !this.disabled ) {
				this[ prop ] = flag;
			}

			if( flag ){
				this.setAttribute('aria-selected', true);
			} else {
				this.removeAttribute('aria-selected');
			}
		};
	},

	_toggleChecked: function( flag, group ){
		var $inputs = (group && group.length) ?  group : this.inputs,
			self = this;

		// toggle state on inputs
		$inputs.each(this._toggleState('checked', flag));

		// give the first input focus
		$inputs.eq(0).focus();

		// update button text
		this.update();

		// gather an array of the values that actually changed
		var values = $inputs.map(function(){
			return this.value;
		}).get();

		// toggle state on original option tags
		this.element
			.find('option')
			.each(function(){
				if( !this.disabled && $.inArray(this.value, values) > -1 ){
					self._toggleState('selected', flag).call( this );
				}
			});

		// trigger the change event on the select
		if( $inputs.length ) {
			this.element.trigger("change");
		}
	},

	_toggleDisabled: function( flag ){
		this.button
			.attr({ 'disabled':flag, 'aria-disabled':flag })[ flag ? 'addClass' : 'removeClass' ]('ui-state-disabled');

		var checkboxes = this.menu.find(".ui-multiselect-checkboxes").get(0);
		var matchedInputs = [];
		var key = "ech-multiselect-disabled";
		var i = 0;
		if(flag) {
			// remember which elements this widget disabled (not pre-disabled)
			// elements, so that they can be restored if the widget is re-enabled.
			matchedInputs = checkboxes.querySelectorAll("input:enabled");
			for(i = 0; i < matchedInputs.length; i++) {
				matchedInputs[i].setAttribute(key, true);
				matchedInputs[i].setAttribute("disabled", "disabled");
				matchedInputs[i].setAttribute("aria-disabled", "disabled");
				matchedInputs[i].parentNode.className = matchedInputs[i].parentNode.className + " ui-state-disabled";
			}
		} else {
			matchedInputs = checkboxes.querySelectorAll("input:disabled");
			for(i = 0; i < matchedInputs.length; i++) {
				if(matchedInputs[i].hasAttribute(key)) {
					matchedInputs[i].removeAttribute(key);
					matchedInputs[i].removeAttribute("disabled");
					matchedInputs[i].removeAttribute("aria-disabled");
					matchedInputs[i].parentNode.className = matchedInputs[i].parentNode.className.replace(" ui-state-disabled", "");
				}
			}
		}

		this.element
			.attr({ 'disabled':flag, 'aria-disabled':flag });
	},

	// open the menu
	open: function( e ){
		var self = this,
			button = this.button,
			menu = this.menu,
			speed = this.speed,
			o = this.options,
			args = [];

		// bail if the multiselectopen event returns false, this widget is disabled, or is already open
		if( this._trigger('beforeopen') === false || button.hasClass('ui-state-disabled') || this._isOpen ){
			return;
		}

		var $container = menu.find('ul').last(),
			effect = o.show,
			pos = button.offset();
		
		var scrollX = window.pageXOffset;
		var scrollY = window.pageYOffset;

		// figure out opening effects/speeds
		if( $.isArray(o.show) ){
			effect = o.show[0];
			speed = o.show[1] || self.speed;
		}

		// if there's an effect, assume jQuery UI is in use
		// build the arguments to pass to show()
		if( effect ) {
      args = [ effect, speed ];
		}

		// set the scroll of the checkbox container
		$container.scrollTop(0).height(o.height);

		this._setMenuWidth();

		// position and show menu
		if ($.ui.position && $.ui.position) {
			menu
				.show()
				.position( o.position )
				.hide();

		// if position utility is not available...
		} else {
			menu.css({
				top: pos.top + button.outerHeight(),
				left: pos.left
			});
		}

		// show the menu, maybe with a speed/effect combo
		$.fn.show.apply(menu, args);

		// select the first option
		this.labels.eq(0).find('input').trigger('focus');

		// Restore window scroll position if altered by setting element focus
		window.scrollTo(scrollX, scrollY);

		button.addClass('ui-state-active');
		this._isOpen = true;
		this._trigger('open');
	},

	// close the menu
	close: function(){
		if(this._trigger('beforeclose') === false){
			return;
		}

		var o = this.options,
		    effect = o.hide,
		    speed = this.speed,
		    args = [];

		// figure out opening effects/speeds
		if( $.isArray(o.hide) ){
			effect = o.hide[0];
			speed = o.hide[1] || this.speed;
		}

    if( effect ) {
      args = [ effect, speed ];
    }

    $.fn.hide.apply(this.menu, args);
		this.button.removeClass('ui-state-active').trigger('blur').trigger('mouseleave');
		this.labels.removeClass("ui-state-hover");
		this._isOpen = false;
		this._trigger('close');
	},

	enable: function(){
		this._toggleDisabled(false);
	},

	disable: function(){
		this._toggleDisabled(true);
	},

	checkAll: function( e ){
		this._toggleChecked(true);
		this._trigger('checkAll');
	},

	uncheckAll: function(){
		this._toggleChecked(false);
		this._trigger('uncheckAll');
	},

	getChecked: function(){
		return this.menu.find('input').filter(':checked');
	},

	destroy: function(){
		// remove classes + data
		$.Widget.prototype.destroy.call( this );

		this.button.remove();
		this.menu.remove();
		this.element.removeClass('ui-multiselect-element').show();

		return this;
	},

	isOpen: function(){
		return this._isOpen;
	},

	widget: function(){
		return this.menu;
	},

	getButton: function(){
	  return this.button;
  },

	// react to option changes after initialization
	_setOption: function( key, value ){
		var menu = this.menu;

		switch(key){
			case 'header':
				menu.find('div.ui-multiselect-header')[ value ? 'show' : 'hide' ]();
				break;
			case 'checkAllText':
				menu.find('a.ui-multiselect-all span').eq(-1).text(value);
				break;
			case 'uncheckAllText':
				menu.find('a.ui-multiselect-none span').eq(-1).text(value);
				break;
			case 'height':
				menu.find('ul').last().height( parseInt(value,10) );
				break;
			case 'minWidth':
				this.options[ key ] = parseInt(value,10);
				this._setButtonWidth();
				this._setMenuWidth();
				break;
			case 'selectedText':
			case 'selectedList':
			case 'noneSelectedText':
				this.options[key] = value; // these all needs to update immediately for the update() call
				this.update();
				break;
			case 'classes':
				menu.add(this.button).removeClass(this.options.classes).addClass(value);
				break;
			case 'multiple':
				menu.toggleClass('ui-multiselect-single', !value);
				this.options.multiple = value;
				this.element[0].multiple = value;
				this.refresh();
		}

		$.Widget.prototype._setOption.apply( this, arguments );
	}
});

})(jQuery);


/*
 * jQuery MultiSelect UI Widget Filtering Plugin 1.4
 * Copyright (c) 2011 Eric Hynds
 *
 * http://www.erichynds.com/jquery/jquery-ui-multiselect-widget/
 *
 * Depends:
 *   - jQuery UI MultiSelect widget
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
*/
(function($){
	var rEscape = /[\-\[\]{}()*+?.,\\\^$|#\s]/g;
	
	$.widget("ech.multiselectfilter", {
		
		options: {
			label: locale.get('Filter') + ':',
			width: null, /* override default width set in css file (px). null will inherit */
			placeholder: locale.get('Enter keywords'),
			autoReset: false
		},
		
		_create: function(){
			var self = this,
				opts = this.options,
				instance = (this.instance = $(this.element).data("multiselect") || $(this.element).data("ech-multiselect") || $(this.element).data("echMultiselect")),
				
				// store header; add filter class so the close/check all/uncheck all links can be positioned correctly
				header = (this.header = instance.menu.find(".ui-multiselect-header").addClass("ui-multiselect-hasfilter")),
				
				// wrapper elem
				wrapper = (this.wrapper = $('<div class="ui-multiselect-filter">'+(opts.label.length ? opts.label : '')+'<input placeholder="'+opts.placeholder+'" type="search"' + (/\d/.test(opts.width) ? 'style="width:'+opts.width+'px"' : '') + ' /></div>').prependTo( this.header ));

			// reference to the actual inputs
			this.inputs = instance.menu.find('input[type="checkbox"], input[type="radio"]');
			
			// build the input box
			this.input = wrapper
			.find("input")
			.bind({
				keydown: function( e ){
					// prevent the enter key from submitting the form / closing the widget
					if( e.which === 13 ){
						e.preventDefault();
					}
				},
				keyup: $.proxy(self._handler, self),
				click: $.proxy(self._handler, self)
			});
			
			// cache input values for searching
			this.updateCache();
			
            function checkAll(flag, group) {
                if (instance.options.renderOnDemand && flag) {
                    instance.renderMore(false, true);
                }

				var filterInstance = $(instance.element).data("multiselectfilter")?.instance || $(instance.element).data("echMultiselectfilter")?.instance;

                var $inputs = (group && group.length) ?
                    group :
                    filterInstance.labels.find('input'),

                    _self = filterInstance,

                    // do not include hidden elems if the menu isn't open.
                    selector = self.instance._isOpen ?
                        ":disabled, :hidden" :
                        ":disabled";

                $inputs = $inputs.not(selector).each(filterInstance._toggleState('checked', flag));

                // update text
                filterInstance.update();

                // figure out which option tags need to be selected
                var values = $inputs.map(function () {
                    return this.value;
                }).get();

                // select option tags
                filterInstance.element
                    .find('option')
                    .filter(function () {
                        if (!this.disabled && $.inArray(this.value, values) > -1) {
                            _self._toggleState('selected', flag).call(this);
                        }
                    });
            }

            // rewrite internal _toggleChecked fn so that when checkAll/uncheckAll is fired,
            // only the currently filtered elements are checked
            if (instance.options.beforeCheckAll) {
                instance._toggleChecked = function (flag, group) {
                    if (flag)
                        instance.options.beforeCheckAll(function () { checkAll(flag, group); });
                    else
                        checkAll(flag, group);
                };
            }
            else
                instance._toggleChecked = checkAll;
			
			// rebuild cache when multiselect is updated
			var doc = $(document).bind("multiselectrefresh", function(){
				self.updateCache();
				self._handler();
			});

			// automatically reset the widget on close?
			if(this.options.autoReset) {
				doc.bind("multiselectclose", $.proxy(this._reset, this));
			}
		},
		
		// thx for the logic here ben alman
		_handler: function( e ){
			var term = $.trim( this.input[0].value.toLowerCase() ),
			
				// speed up lookups
				rows = this.rows, inputs = this.inputs, cache = this.cache;
			
			if( !term ){
				rows.show();
            } else {
                // render on demand is enabled and we don't have all options rendered yet
                if (this.instance.options.renderOnDemand && this.instance.options.totalOptions > rows.length) {
                    // make sure we have enough rendered options that match search
                    this.instance.renderMore();
				}

				if (this.element[0].id === "hFilterList")
					Storyboard.HFilterLayout.loadMoreListOptions(true, true);

				rows.hide();
				
				var regex = new RegExp(term.replace(rEscape, "\\$&"), 'gi');
				
				this._trigger( "filter", e, $.map(cache, function(v, i){
					if( v.search(regex) !== -1 ){
						rows.eq(i).show();
						return inputs.get(i);
					}
					
					return null;
				}));
			}

			// show/hide optgroups
			this.instance.menu.find(".ui-multiselect-optgroup-label").each(function(){
				var $this = $(this);
				var isVisible = $this.nextUntil('.ui-multiselect-optgroup-label').filter(function(){
				  return $.css(this, "display") !== 'none';
				}).length;
				
				$this[ isVisible ? 'show' : 'hide' ]();
			});
		},

		_reset: function() {
			this.input.val('').trigger('keyup');
		},
		
		updateCache: function(){
			// each list item
			this.rows = this.instance.menu.find(".ui-multiselect-checkboxes li:not(.ui-multiselect-optgroup-label)");
			
			// cache
			this.cache = this.element.children().map(function(){
				var self = $(this);
				
				// account for optgroups
				if( this.tagName.toLowerCase() === "optgroup" ){
					self = self.children();
				}
				
				return self.map(function(){
					return this.innerHTML.toLowerCase();
				}).get();
			}).get();
		},
		
		widget: function(){
			return this.wrapper;
        },

        filter: function () {
            this._handler();
        },
		
		destroy: function(){
			$.Widget.prototype.destroy.call( this );
			this.input.val('').trigger("keyup");
			this.wrapper.remove();
		}
	});
})(jQuery);